export default "__VITE_ASSET__Co85ISH0__"